/** URLs canônicas das páginas do menu de perfil e áreas administrativas. */
export const APP_PATHS = {
  SUBSCRIPTION: '/subscription',
  MY_COMPANY: '/my-company',
  BILLING: '/faturamento',
  SETTINGS: '/settings',
  USERS: '/users',
  ROLES: '/roles',
  /**
   * Conexões saiu de dentro de Atendimento e virou menu de primeiro nível:
   * era o item que as pessoas mais tinham dificuldade de achar. A URL
   * acompanhou o menu — `/tickets/channels` dava a entender que conexão era
   * assunto de ticket.
   */
  CHANNELS: '/connections',
  /** Templates, saúde do número e custos — sub-recurso de uma conexão. */
  WHATSAPP_OFFICIAL: '/connections/whatsapp-official',
  /** Apps de produtividade da Loja moram em Ferramentas (`/tools`). */
  TOOLS: '/tools',
  MIND_MAPS: '/tools/mind-maps',
  MIND_MAPS_TRASH: '/tools/mind-maps/trash',
};

export const getMindMapPath = (mindMapId) => `${APP_PATHS.MIND_MAPS}/${mindMapId}`;

export const getRoleEditPath = (roleId) => `${APP_PATHS.ROLES}/${roleId}/edit`;
export const getRoleNewPath = () => `${APP_PATHS.ROLES}/new`;

/** Chave em `location.state` para abrir a edição de uma conexão específica ao redirecionar para Conexões. */
export const OPEN_CONNECTION_STATE = 'openConnectionId';
/** Chave em `location.state` para pré-selecionar uma aba do modal de edição da conexão. */
export const OPEN_CONNECTION_TAB_STATE = 'openConnectionTab';

export const getConnectionEditPath = (whatsappId, tab) => ({
  pathname: APP_PATHS.CHANNELS,
  state: {
    [OPEN_CONNECTION_STATE]: whatsappId,
    ...(tab ? { [OPEN_CONNECTION_TAB_STATE]: tab } : {}),
  },
});
